<div class="invoice-line-form">
  <div class="header-modal mb-0">
    <div class="main-title w-100 mt-0 mb-0">
      <h3>License Info</h3>
    </div>
    <span class="close-dialog" mat-dialog-close>
          <i class="material-icons">close</i>
        </span>
  </div>
  <div class="content pt-3">
    <form *ngIf="formGroup" [formGroup]="formGroup">
      <div class="info-section">
        <div class="info-section-inner">
          <div class="input-wrap">
            <div class="label-wrap with-icon">
              <label for="licenseNumber">License Number <span class="required-symbol">*</span></label>
              <img matTooltip="Data is new or has been changed!" *ngIf="data?.isFromChangeRequest && fieldModified('licenseNumber')" src="assets/images/icons/change-indicator.svg" alt="Changed Icon" />
            </div>
            <input appInputTrimmer formControlName="licenseNumber" id="licenseNumber" placeholder="License Number">
            <span *ngIf="tooltipService.getState('licenseNumber')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('licenseNumber', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'License Number'">
              </app-tooltip>
            </span>
          </div>
          <div class="input-wrap input-mat-select">
            <div class="label-wrap with-icon">
              <label>Country Issued <span class="required-symbol">*</span></label>
              <img matTooltip="Data is new or has been changed!"
                   *ngIf="data?.isFromChangeRequest && fieldModified('countryIssued')"
                   src="assets/images/icons/change-indicator.svg" alt="Changed Icon"/>
            </div>
            <app-portal-select
              formControlName="countryIssued"
              [items]="countries"
              [withFilter]="true"
              [required]="true"
              placeholder="Country Issued"
              itemId="id"
              itemName="name"
              (selectionChange)="staffCountrySelected($event)">
              <ng-template let-item #option>
                {{item?.name}}
              </ng-template>
            </app-portal-select>
          </div>
          <div class="input-wrap input-mat-select">
            <div class="label-wrap with-icon">
              <label>State Issued <span class="required-symbol">*</span></label>
              <img matTooltip="Data is new or has been changed!"
                   *ngIf="data?.isFromChangeRequest && fieldModified('stateIssued')"
                   src="assets/images/icons/change-indicator.svg" alt="Changed Icon"/>
            </div>
            <app-portal-select
              formControlName="stateIssued"
              [items]="states"
              [withFilter]="true"
              [required]="true"
              placeholder="State Issued"
              itemId="id"
              itemName="name">
              <ng-template let-item #option>
                {{item?.name}}
              </ng-template>
            </app-portal-select>
          </div>
          <div class="input-wrap">
            <label>Effective Date <span class="required-symbol">*</span></label>
            <img matTooltip="Data is new or has been changed!"
                 *ngIf="data?.isFromChangeRequest && fieldModified('effectiveDate')"
                 src="assets/images/icons/change-indicator.svg" alt="Changed Icon"/>
            <mat-datepicker #pickerDate></mat-datepicker>
            <mat-datepicker-toggle id="roleLicenseEffectiveDate" [for]="pickerDate" matSuffix></mat-datepicker-toggle>
            <input [matDatepicker]="pickerDate" [max]="dateNow" formControlName="effectiveDate" matInput
                   (dateChange)="onEffectiveDateChange(formGroup.get('effectiveDate').value)"
                   type="datetime" placeholder="MM/DD/YYYY">
          </div>
          <div class="input-wrap">
            <label>Expiration/Renewal Date <span class="required-symbol">*</span></label>
            <img matTooltip="Data is new or has been changed!"
                 *ngIf="data?.isFromChangeRequest && fieldModified('expirationDate')"
                 src="assets/images/icons/change-indicator.svg" alt="Changed Icon"/>
            <mat-datepicker #pickerDate1></mat-datepicker>
            <mat-datepicker-toggle id="roleLicenseExpirationDate" [for]="pickerDate1" matSuffix></mat-datepicker-toggle>
            <input [matDatepicker]="pickerDate1"
                   [min]="formGroup.get('effectiveDate').value ? expirationDateMin : dateClosedMin"
                   formControlName="expirationDate" matInput
                   type="datetime" placeholder="MM/DD/YYYY">
          </div>
        </div>
      </div>
    </form>

    <div class="container other-files-container" style="padding: 0;">
      <p class="file-title" style="margin: 0;">License Document <span class="required-symbol">*</span></p>
      <p style="margin-top: 10px;">
        Please Upload your License PDF Format here
      </p>
      <div class="other-files row pt-4 mb-10">
        <div class="files-list ml-20 pl-0">
          <div *ngIf="file != null" class="inline-files">
            <div class="file-plc">
              <div (click)="fileClicked(file)" class="logo mr-20">
                <img alt="" src="{{fileIcon}}"/>
              </div>
              <div class="info">
                <p (click)="fileClicked(file)" class="title font-14 mr-30">{{ file?.name }}</p>
                <p class="size font-12 mr-30">{{ file === 0 ? 0 : (file?.size / 1000) }} KB</p>

                <div (click)="onRemoveFile()" class="remove-file g-cursor-pointer">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <mat-progress-bar [hidden]="!file?.progress"
                              [value]="file?.progress"
                              color="primary"
                              mode="determinate"></mat-progress-bar>
            <div class="horizontal-line"></div>
          </div>
        </div>
        <ngx-dropzone (change)="onFileAdd($event)"
                      [accept]="'.pdf'"
                      [maxFileSize]="5242880"
                      [multiple]="true"
                      [ngClass]="{'file-required-error' : formGroup.get('attachment')?.dirty }"
                      class="dropzone files-drop col-md-12">
          <ngx-dropzone-label>
            <img alt="" src="{{fileUploadIcon}}"/>
            <p class="portal-upload-line">Drag and drop</p>
            <p class="portal-upload-line">Or</p>
            <p class="portal-upload-browse"><span>Browse</span></p>
          </ngx-dropzone-label>
        </ngx-dropzone>
      </div>
    </div>

    <!-- Added the disable check when used from the Staff approval request -->
    <div *ngIf="!data?.disableForm" class="right-side">
      <div class="button-container">
        <cmp-button [class]="'cancel mr-20'" text="Close" (click)="cancel()"></cmp-button>
        <app-spinner-button (spinClick)="onSave($event)"></app-spinner-button>
      </div>
    </div>
  </div>

  <!-- For Staff approval request, if disabled then only close the modal (readonly) -->
  <div *ngIf="data?.disableForm" class="right-side">
    <div class="button-container">
      <cmp-button [class]="'primary mr-20'" text="Close" (click)="close()"></cmp-button>
    </div>
  </div>
</div>








